import { render, staticRenderFns } from "./AzureCallback.vue?vue&type=template&id=56178843"
import script from "./AzureCallback.vue?vue&type=script&lang=js"
export * from "./AzureCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports